/*
  A lista do Classificar com a cara da loja (18/09/2026).

  A lista que abria era a nativa do <select>, desenhada pelo navegador, e
  nenhuma folha de estilo alcança. Aqui o <select> original fica no HTML,
  escondido, e ganha por cima um botão e uma lista desenhados em
  `assets/atd-filtros.css`, seção 2b. Escolher uma opção muda o valor do
  <select> e dispara `change`, que é o evento que o tema escuta para
  reordenar a listagem. Sem este arquivo, o <select> nativo continua
  funcionando.

  O tema redesenha a gaveta de filtros a cada filtro aplicado, e o <select>
  novo chega sem a lista. Por isso um MutationObserver refaz o trabalho em
  qualquer <select> de ordenação que apareça.

  Também tira o traço de "Ordem alfabética, A–Z": o texto vem da tradução da
  própria Shopify, e a loja não usa travessão nem meia-risca. Vira
  "de A a Z".

  E troca o nome do grupo "Tipo de Produto" por "Tipo de peça" (18/09
  noite). O nome vem do app Search & Discovery; o resto da loja (menu,
  mega menu, home) chama de "Tipo de peça", e o cliente procurou por esse
  nome dentro do Filtrar.
*/
(function () {
  'use strict';

  var SETA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var VISTO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var conta = 0;

  function limparTexto(texto) {
    return texto
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b([A-Z])\s*[–—-]\s*([A-Z])\b/, 'de $1 a $2');
  }

  function limparOpcoes(raiz) {
    var opcoes = (raiz || document).querySelectorAll('select[name="sort_by"] option, .sorting-filter__options [role="option"], .sorting-filter .facets__status');
    for (var i = 0; i < opcoes.length; i++) {
      var o = opcoes[i];
      if (o.children.length) continue;
      if (/[A-Z]\s*[–—]\s*[A-Z]/.test(o.textContent)) o.textContent = limparTexto(o.textContent);
    }
  }

  var NOMES = { 'Tipo de Produto': 'Tipo de peça' };

  function trocarNomes(raiz) {
    var rotulos = (raiz || document).querySelectorAll('.facets__label, .facets__pill-label, .facets-remove__label');
    for (var i = 0; i < rotulos.length; i++) {
      var r = rotulos[i];
      if (r.children.length) continue;
      var t = r.textContent.trim();
      for (var velho in NOMES) {
        if (t === velho) r.textContent = NOMES[velho];
        else if (t.indexOf(velho + ':') === 0) r.textContent = NOMES[velho] + t.slice(velho.length);
      }
    }
    /* A pastilha do filtro marcado tem o X dentro, entao so o primeiro
       texto dela muda. */
    var pilulas = (raiz || document).querySelectorAll('.facets-remove__pill');
    for (var j = 0; j < pilulas.length; j++) {
      var no = pilulas[j].firstChild;
      while (no && no.nodeType !== 3) no = no.nextSibling;
      if (!no) continue;
      for (var nome in NOMES) {
        if (no.nodeValue.indexOf(nome) !== -1) no.nodeValue = no.nodeValue.replace(nome, NOMES[nome]);
      }
    }
  }

  function montar(select) {
    if (select.dataset.atdOrdem) return;
    var caixa = select.parentElement;
    if (!caixa || !select.closest('.facets--drawer')) return;
    select.dataset.atdOrdem = '1';
    conta += 1;

    var id = 'atd-ordem-' + conta;
    var rotulo = select.id ? document.querySelector('label[for="' + select.id + '"]') : null;
    if (rotulo && !rotulo.id) rotulo.id = id + '-rotulo';

    var raiz = document.createElement('div');
    raiz.className = 'atd-ordem';

    var botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'atd-ordem__botao';
    botao.setAttribute('aria-haspopup', 'listbox');
    botao.setAttribute('aria-expanded', 'false');
    botao.setAttribute('aria-controls', id);
    if (rotulo) botao.setAttribute('aria-labelledby', rotulo.id + ' ' + id + '-valor');
    botao.innerHTML = '<span class="atd-ordem__valor" id="' + id + '-valor"></span>' + SETA;

    var lista = document.createElement('ul');
    lista.className = 'atd-ordem__lista';
    lista.id = id;
    lista.setAttribute('role', 'listbox');
    if (rotulo) lista.setAttribute('aria-labelledby', rotulo.id);
    lista.hidden = true;

    function desenhar() {
      lista.innerHTML = '';
      for (var i = 0; i < select.options.length; i++) {
        var op = select.options[i];
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'atd-ordem__opcao';
        b.setAttribute('role', 'option');
        b.setAttribute('aria-selected', op.selected ? 'true' : 'false');
        b.dataset.valor = op.value;
        b.innerHTML = '<span></span>' + VISTO;
        b.firstChild.textContent = limparTexto(op.textContent);
        li.appendChild(b);
        lista.appendChild(li);
      }
      var atual = select.options[select.selectedIndex];
      botao.querySelector('.atd-ordem__valor').textContent = atual ? limparTexto(atual.textContent) : '';
    }

    function opcoes() {
      return lista.querySelectorAll('.atd-ordem__opcao');
    }

    function abrir() {
      desenhar();
      lista.hidden = false;
      raiz.classList.add('is-aberta');
      botao.setAttribute('aria-expanded', 'true');
      var marcada = lista.querySelector('[aria-selected="true"]') || opcoes()[0];
      if (marcada) marcada.focus();
    }

    function fechar(devolverFoco) {
      if (lista.hidden) return;
      lista.hidden = true;
      raiz.classList.remove('is-aberta');
      botao.setAttribute('aria-expanded', 'false');
      if (devolverFoco) botao.focus();
    }

    function escolher(valor) {
      fechar(true);
      if (select.value === valor) return;
      select.value = valor;
      // O componente também tem os botões de rádio da lista de computador,
      // com o mesmo name. O formulário lê os dois; se o rádio continuar na
      // opção antiga, ele ganha e a ordem não muda.
      var componente = select.closest('sorting-filter-component');
      var radios = componente ? componente.querySelectorAll('input[name="sort_by"]') : [];
      for (var i = 0; i < radios.length; i++) radios[i].checked = radios[i].value === valor;
      desenhar();
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    botao.addEventListener('click', function () {
      if (lista.hidden) abrir();
      else fechar(false);
    });

    botao.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        abrir();
      }
    });

    lista.addEventListener('click', function (e) {
      var b = e.target.closest('.atd-ordem__opcao');
      if (b) escolher(b.dataset.valor);
    });

    lista.addEventListener('keydown', function (e) {
      var todas = Array.prototype.slice.call(opcoes());
      var i = todas.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        todas[Math.min(i + 1, todas.length - 1)].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        todas[Math.max(i - 1, 0)].focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        todas[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        todas[todas.length - 1].focus();
      } else if (e.key === 'Escape') {
        // Sem isto o Esc fecha a gaveta inteira, não só a lista.
        e.preventDefault();
        e.stopPropagation();
        fechar(true);
      } else if (e.key === 'Tab') {
        fechar(false);
      }
    });

    document.addEventListener('pointerdown', function (e) {
      if (!raiz.contains(e.target)) fechar(false);
    });

    select.addEventListener('change', desenhar);

    raiz.appendChild(botao);
    raiz.appendChild(lista);
    caixa.appendChild(raiz);
    desenhar();
  }

  function varrer() {
    limparOpcoes();
    trocarNomes();
    var selects = document.querySelectorAll('.facets--drawer select[name="sort_by"]');
    for (var i = 0; i < selects.length; i++) montar(selects[i]);
  }

  var agendado = false;
  function agendar() {
    if (agendado) return;
    agendado = true;
    // setTimeout e não requestAnimationFrame: com a aba em segundo plano o
    // navegador suspende o rAF, e a gaveta redesenhada ficava sem a lista.
    setTimeout(function () {
      agendado = false;
      varrer();
    }, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer);
  else varrer();

  new MutationObserver(agendar).observe(document.documentElement, { childList: true, subtree: true });
})();
